// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageSizeInput_root__1sM4K","input":"ImageSizeInput_input__2M7v4"};